import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Station } from '../../class/station';

@Injectable()
export class StationService extends WebService {

    public getStation (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('employee,route.stations'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/stations?${params}`, options);
    }

    public newStation(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/stations`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateStation(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/stations/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteStation(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/stations/${id}`, { headers: this.headers } );
    }

    public infoStation(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/stations?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/station/station.service.ts